// extracted by mini-css-extract-plugin
export default {"catalogByServiceItem":"c-h_ff","catalogByServiceItem__title":"c-h_fg"};